// controls/view.js
var Marionette = require('backbone.marionette');
var template = require('./template.hbs');
var $ = require('jquery');

var Radio = require('backbone.radio');
var routerChannel = Radio.channel('router');

module.exports = Marionette.ItemView.extend({
	template: template,
	tagName: 'div',
  className: 'controls-layout',

  initialize: function(){
    var scope = this;

		this.listenTo(routerChannel, 'map:update:boundary', this.update);
		this.listenTo(UCS.App.MapState, 'change:zoomed', this.updateButtons);
  },

	ui: {
		'btnCongressional': ".boundary_select .btn-congressional",
		'btnStateAssembly': ".boundary_select .btn-state-assembly",
		'btnStateSenate': ".boundary_select .btn-state-senate",
		'btnCounty': ".boundary_select .btn-county",
		reset: ".reset"
	},

  events: {
		'click @ui.btnCongressional': "updateRoute",
		'click @ui.btnStateAssembly': "updateRoute",
		'click @ui.btnStateSenate': "updateRoute",
		'click @ui.btnCounty': "updateRoute",
		'click @ui.reset': 'resetRoute'
  },

	onAttach: function(){
		this.update();
		this.updateButtons();
	},

  update: function(){
    var d = UCS.App.MapState.get('selection');
		var type = UCS.App.MapState.get('type');

		this.$('.boundary_select button').removeClass('active');
		this.$(".boundary_select button[value='" + type + "']").addClass('active');
  },

	updateRoute: function(event){
		var type = event.currentTarget.value;

		UCS.App.Router.navigate('map/' + type, {trigger: true});

		if( UCS.App.MapState.get('zoomed') ){
			this.ui.reset.removeClass('inactive');
		}
	},

	resetRoute: function(){
		var type = UCS.App.MapState.get('type');
		UCS.App.MapState.set('zoomed', false);
		UCS.App.Router.navigate('map/' + type, {trigger: true});
	},

	updateButtons: function(){
		if( UCS.App.MapState.get('zoomed') === true ){
			this.ui.reset.removeClass('disabled');
		}else if ( UCS.App.MapState.get('zoomed') === false){
			this.ui.reset.addClass('disabled');
		}
	},
	onDestroy: function(){
	}
});
